/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/ss-tos-page.pug';
import metadata from './metadata.json';
import ssTosPapers from './data/ssTosPapers.json';

export default function register() {
  page('/legal/ss-tos', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ssTosPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/ss-tos/ssTos.js